module.exports = __webpack_public_path__ + "img/beef.bd8c51a2.jpg";